  /* eslint-disable no-underscore-dangle */
import { INIT_ESTIMATOR_APP, LOAD_MODEL_VIEW, LOAD_TRIM_VIEW, ZIP_CODE_MODAL_OPENED } from '../constants';

/**
 * Initialize the App
 * @returns {function(*)}
 */
export function initAction() {
  return (dispatch) => {
    const dtmCheck = setInterval(() => {
      if (window._satellite && window.dtmTrackingDataLayer) {
        dispatch({
          type: INIT_ESTIMATOR_APP
        });
        clearInterval(dtmCheck);
      }
    }, 10);
  };
}

/**
 * Load Model view on selection of a model
 * @param model - the model line code
 * @returns {function(*)}
 */
export function loadModelView(model) {
  return (dispatch) => {
    dispatch({
      type: LOAD_MODEL_VIEW,
      model
    });
  };
}

/**
 * Load Trim view on selection of a Trim
 * @param model - the model line code
 * @param trim - the trim n code
 * @returns {function(*)}
 */
export function loadTrimView(model, trim) {
  return (dispatch) => {
    dispatch({
      type: LOAD_TRIM_VIEW,
      model,
      trim
    });
  };
}

/**
 * Open the Zip Code Modal window if there is no existing zip code in GeoData
 * @returns {function(*)}
 */
export function openZipModalAction() {
  return (dispatch) => {
    dispatch({
      type: ZIP_CODE_MODAL_OPENED
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/views.js
 **/